export enum EntityType {
    ProcessingActivity = 1,
    System = 2,
    LegalEntity = 3,
    Policy = 4,
    IncidentLog = 5,
    AnnualWheelActivity = 6,
    Task = 7,
    Risk = 8,
    LegalEntityAudit = 9,
    LegalEntityClassification = 10,
    LegalEntityAuditGroup = 11,
    InternalAssessment = 12,
    LegalEntityDocument = 13,
    Contract = 14,
    User = 17,
    ContractDocument = 18,
    BusinessArea = 19,
    ContractType = 20,
    EntityTemplate = 21,
    PaymentTerm = 22,
    Tag = 23,
    TaskDocument = 24,
    SystemDocument = 25,
    PolicyDocument = 26,
    IncidentLogDocument = 27,
    ProcessingActivityDocument = 28,
    FrameworkControl = 29,
    DocumentType = 30,
    ComplianceArea = 31,
    DeletionPeriod = 32,
    Certification = 33,
    SecurityMeasures = 34,
    DataCategory = 35,
    DataSubject = 36,
    LegalBasis = 37,
    InternalAssessmentGroup = 40,
    // Not an assessable entity: the organisation as a whole, which a risk scenario can apply to like it applies
    // to an entity type.
    Organisation = 41,
    Process = 42,
    ProcessDocument = 43,
}
